module.exports = __webpack_public_path__ + "static/scale-model-of-oso-de-oro-park-in-fresno-california-f25dcfdc2ece28f89c6f33ec8f44ee4c.png";